"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ var defaultTranslations = exports.defaultTranslations = {
    update: 'Update',
    updateYourBrowser: 'Update your browser for more security, speed and the best experience on this site.',
    yourBrowserIsOutdated: 'Your web browser ({brow_name}) is out of date.'
};
var translationsNamespace = exports.translationsNamespace = 'outdated-browser-info'; //# sourceMappingURL=defaultTranslations.js.map
